module.exports = __webpack_public_path__ + "static/img/icon_logo.aaa85217.png";